module.exports = __webpack_public_path__ + "static/media/select-cross-icon.1937b563.svg";